<script>
    import Spinner from 'vue-simple-spinner';
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: ['sourceprop'],
        components: {Spinner},
        data() {
            return {
                showNote: false,
                source: null,
                form: new Form({
                    notification_cause: '',
                    note: '',
                }),
            }
        },
        mounted() {
            this.source = this.sourceprop
        },
        watch: {
        },
        methods: {
            getFirstRadioId(review) {
                return '#notifyReviewFirstRadio' + review.id
            },
            getSecondRadioId(review) {
                return '#notifyReviewSecondRadio' + review.id
            },
            onSubmit() {
                this.form
                    .submit('post', this.source)
                    .then(response => {
                        $('#notifyReviewModal').modal('hide');
                        window.alerts.success('Segnalazione inviata correttamente');
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/ReviewNotificationForm.vue